/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HomeJiraTicket = {
    id: string;
    key: string;
    title: string;
    counterparty_name?: (string | null);
    is_assigned_to_viewer?: boolean;
    is_reported_by_viewer?: boolean;
    status: HomeJiraTicket.status;
    url: string;
};

export namespace HomeJiraTicket {

    export enum status {
        NOT_STARTED = 'not_started',
        ON_TRACK = 'on_track',
        AT_RISK = 'at_risk',
        COMPLETE = 'complete',
    }


}

